import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import { Group, Skeleton } from "@mantine/core";
const UserSkeleton = () => {
    return (_jsxs(Group, { spacing: 8, align: "center", children: [_jsx(Skeleton, { circle: true, height: 21, width: 21 }), _jsx(Skeleton, { height: 20, width: 80 })] }));
};
export default memo(UserSkeleton);
